module.exports = __webpack_public_path__ + "static/media/designPatent_30-1018449.8f60b32f.png";